import { CharacterAttack } from '../attacks/CharacterAttack';
import { CharacterBase } from '../CharacterBase';
import { CharacterEnemy } from '../CharacterEnemy';
import { CharacterStateMachineEnemy } from '../statemachines/CharacterStateMachine';
const CONFIG = {
  id: 'dragon',
  spineid: 'dragon',
  combatStyle: 'STATIC',
  speed: 0,
  health: 400,
  coins: 10,
  stagger: false,
  knockdown: false,
  attackRate: 0.25,
  attackRange: 2000,
  attacks: [],
};
const ATTACKS = {
  bite: {
    id: 'bite',
    name: 'bite',
    animation: 'bite',
    damage: 50,
    knockdown: true,
  },
  firestormlow: {
    id: 'firestormlow',
    name: 'firestormlow',
    animation: 'firestormlow',
    damage: 50,
    knockdown: true,
  },
  firestormhigh: {
    id: 'firestormlow',
    name: 'firestormlow',
    animation: 'firestormlow',
    damage: 50,
    knockdown: true,
  },
};
export class CharacterDragon extends CharacterEnemy {
  constructor(scene, x, y, config, collisionmap) {
    super(scene, x, y, CONFIG, collisionmap);

    this._grabbable = false;
    this.attackCount = -1;
    this.attackBite = new DragonAttackBite(scene, this, ATTACKS.bite);
    this.attackFirestormLow = new DragonAttackFirestormLow(scene, this, ATTACKS.firestormlow);
    this.attackFirestormHigh = new DragonAttackFirestormHigh(scene, this, ATTACKS.firestormhigh);
    this.attackPattern = [
      this.attackBite,
      this.attackFirestormLow,
      this.attackBite,
      this.attackFirestormHigh,
    ];
    this.bodyCollider.enabled = false;
    this.shadow.visible = false;
    this.isBoss = true;
    // this.debugBodyDepth = scene.add.circle(0, 0, 30, 0x00ffff);
    // this.debugAttackDepth = scene.add.circle(0, 0, 30, 0xff0000);
  }

  update(...args) {
    super.update(...args);
    // this.debugBodyDepth.x = this.bodyCollider.x;
    // this.debugBodyDepth.y = this.bodyCollider.depth;
    // this.debugAttackDepth.x = this.attackCollider.x;
    // this.debugAttackDepth.y = this.attackCollider.depth;
  }

  get canDamage() {
    // return !this.attackCollider.enabled;
    return true;
  }

  get characterBounds() {
    return this._characterBounds;
  }

  createStateMachine() {
    return new CharacterStateMachineDragon(this.scene, this);
  }

  chooseAttack() {
    this.attackCount++;
    return this.attackPattern[this.attackCount % this.attackPattern.length];
  }

  stagger() {}
  knockdown() {}
  updateMovement() {}
  findPathToHero() {}
  updateBodyCollider() {
    this.depth = this._bodyCollider.depth;
  }

  die() {
    this.clearPath();
    this.velocity.x = this.velocity.y = 0;
    this.bodyCollider.enabled = false;
    this.setState(CharacterBase.STATES.DEAD);
    this.scene.tweens.add({
      targets: this.sprite,
      alpha: 0,
      duration: 500,
    });
  }
  get isFullyDead() {
    return this.isDead && this.sprite.alpha <= 0;
  }
}

// =============================================================================================
// STATE MACHINE
// =============================================================================================

class CharacterStateMachineDragon extends CharacterStateMachineEnemy {
  idle(delta) {
    this.character.visible = false;
    super.idle(delta);
    this.character.faceDirection = 1;
  }
  attack(delta) {
    this.character.visible = true;
    super.attack(delta);
    this.character.faceDirection = 1;
  }
}

// =============================================================================================
// ATTACKS
// =============================================================================================

class DragonAttackBite extends CharacterAttack {
  constructor(...args) {
    super(...args);
  }
  updateAttackCollider() {}

  _triggerAttackAnimation() {
    this.character.attackCollider.enabled = false;
    this.character.x = this.character.heroTarget.x;
    this.character.y = this.scene.viewport.y + 550;
    this.character.sprite.y = -550;
    this.character.sprite.x = 0;
    this._attackCollider = false;

    this.character.bodyCollider.enabled = true;
    this.character.bodyCollider.x = this.character.x - 150;
    this.character.bodyCollider.y = this.character.y + this.character.sprite.y;
    this.character.bodyCollider.width = 150;
    this.character.bodyCollider.height = 1;
    this.character.bodyCollider.depth = this.character.bodyCollider.y + 525;
    this.scene.tweens.add({
      targets: this.character.bodyCollider,
      height: 550,
      duration: 500,
      delay: 500,
    });

    this.character.playAnimation('vertical_bite_intro', false, this._triggerAttackAnim, this);
  }

  _triggerAttackAnim() {
    this.character.attackCollider.enabled = true;
    this.character.attackCollider.x = this.character.x - 150;
    this.character.attackCollider.y = this.character.y - 200;
    this.character.attackCollider.width = 160;
    this.character.attackCollider.height = 200;
    this.scene.tweens.add({
      targets: this.character.bodyCollider,
      height: 550,
      duration: 250,
    });
    this.playSFX('dragon_bite');
    this.scene.tweens.add({
      targets: this.character.attackCollider,
      width: 0,
      x: '+=' + this.character.attackCollider.width * 0.5,
      duration: 100,
      onComplete: this.clearAttackCollider,
      onCompleteScope: this,
    });

    this.character.scene.shake();
    this.character.playAnimation('vertical_bite', false, this._triggerOutroAnim, this);
  }

  _triggerOutroAnim() {
    this.clearAttackCollider();
    this.scene.tweens.add({
      targets: this.character.bodyCollider,
      height: 0,
      duration: 1000,
    });
    this.character.playAnimation('vertical_bite_outro', false, this.completeAttack, this);
  }

  clearAttackCollider() {
    this.character.attackCollider.enabled = false;
  }
}

class DragonAttackFirestormLow extends CharacterAttack {
  constructor(...args) {
    super(...args);
  }

  updateAttackCollider() {}

  _triggerAttackAnimation() {
    this._character.attackCollider.enabled = false;
    this.character.x = this.scene.viewport.x + this.scene.viewport.width + 150;
    this.character.y = this.character.heroTarget.y - 150;
    this.character.sprite.y = -225;
    this.character.sprite.x = 0;

    this.character.bodyCollider.enabled = true;
    this.character.bodyCollider.x = this.character.x - 25;
    this.character.bodyCollider.y = this.character.y + this.character.sprite.y + 150;
    this.character.bodyCollider.width = 275;
    this.character.bodyCollider.height = 150;
    this.character.bodyCollider.depth = this.character.bodyCollider.y + 200;
    this.scene.tweens.add({
      targets: this.character.bodyCollider,
      x: '-=' + 450,
      duration: 1100,
    });

    this.character.playAnimation('horizontal_intro', false, this._triggerAttackAnim, this);
  }

  _triggerAttackAnim() {
    this.character.attackCollider.enabled = true;
    this.character.attackCollider.x = this.character.x - 280;
    this.character.attackCollider.y = this.character.y;
    this.character.attackCollider.width = 0;
    this.character.attackCollider.height = 60;
    this.character.attackCollider.depth = this.character.bodyCollider.depth;
    this.scene.tweens.add({
      targets: this.character.attackCollider,
      width: 1400,
      x: this.character.x - 1680,
      duration: 200,
      hold: 1500,
      yoyo: true,
      onComplete: this.clearAttackCollider,
      onCompleteScope: this,
    });

    this.scene.tweens.add({
      targets: [this.character, this.character.attackCollider, this.character.bodyCollider],
      y: '-=100',
      duration: 1000,
      yoyo: true,
    });

    this.character.scene.shake(1750);
    this.playSFX('dragon_fire');
    this.character.playAnimation('horizontal_fire', false, this._triggerOutroAnim, this);
  }

  _triggerOutroAnim() {
    this.clearAttackCollider();
    this.scene.tweens.add({
      targets: this.character.bodyCollider,
      x: '+=' + 475,
      duration: 1100,
      delay: 3750,
    });
    this.character.playAnimation('horizontal_outro', false, this.completeAttack, this);
  }

  clearAttackCollider() {
    this.character.attackCollider.enabled = false;
  }
}

class DragonAttackFirestormHigh extends CharacterAttack {
  constructor(...args) {
    super(...args);
  }

  updateAttackCollider() {}

  _triggerAttackAnimation() {
    this._character.attackCollider.enabled = false;

    this.character.x = this.character.heroTarget.x;
    this.character.y = this.scene.viewport.y + 550;
    this.character.sprite.y = -550;
    this.character.sprite.x = 0;

    this.character.bodyCollider.enabled = true;
    this.character.bodyCollider.x = this.character.x - 120;
    this.character.bodyCollider.y = this.character.y + this.character.sprite.y;
    this.character.bodyCollider.width = 180;
    this.character.bodyCollider.height = 1;
    this.character.bodyCollider.depth = this.character.bodyCollider.y + 550;
    this.scene.tweens.add({
      targets: this.character.bodyCollider,
      height: 250,
      duration: 1000,
      yoyo: true,
      hold: 4000,
    });

    this.character.playAnimation('vertical_fire_intro', false, this._triggerAttackAnim, this);
  }

  _triggerAttackAnim() {
    this.character.attackCollider.enabled = true;
    this.character.attackCollider.x = this.character.x - 30;
    this.character.attackCollider.y = this.character.y - 550;
    this.character.attackCollider.width = 60;
    this.character.attackCollider.height = 100;
    const dist =
      this.character.x > this.scene.viewport.x + this.scene.viewport.width * 0.5
        ? '-=350'
        : '+=350';
    this.scene.tweens.add({
      targets: this.character.attackCollider,
      height: 550,
      duration: 200,
      hold: 1500,
      yoyo: true,
    });
    this.playSFX('dragon_fire');

    this.scene.tweens.add({
      targets: [this.character, this.character.attackCollider, this.character.bodyCollider],
      x: dist,
      duration: 1750,
    });
    this.character.scene.shake(1750);
    this.character.playAnimation('vertical_fire_fire', false, this._triggerOutroAnim, this);
  }

  _triggerOutroAnim() {
    this.character.attackCollider.enabled = false;
    this.character.playAnimation('vertical_fire_outro', false, this.completeAttack, this);
  }
}
